import React, { FC, ChangeEvent } from 'react';
import {
    StyledDropdown,
    StyledLabel,
    Wrapper
} from './SearchInitiationMobileModal.styles';
import { useDispatch, useSelector } from 'react-redux';

import { updateFilter, durationSelector } from '../../../reducers/filters';

export const SelectMaxTravelTime: FC = () => {
    const reduxDispatch = useDispatch();

    const { selectedValue, options } = useSelector(durationSelector);

    const onDurationChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        reduxDispatch(updateFilter('duration', evt.currentTarget.value));
    };

    const durationLabel = 'Max travel time';

    return (
        <Wrapper>
            <StyledLabel isBold>{durationLabel}</StyledLabel>
            <StyledDropdown
                id="duration_mobile"
                onChange={onDurationChange}
                value={selectedValue}
                name="duration"
                aria-label="Max travel time"
                data-testid="select-max-travel-time-dropdown_modal_mobile"
            >
                {options?.map((option) => {
                    const { label, value } = option;

                    return (
                        <option key={`modal-duration-${value}`} value={value}>
                            {label}
                        </option>
                    );
                })}
            </StyledDropdown>
        </Wrapper>
    );
};
